import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Icon,
  Button,
  Table,
  Label,
} from 'semantic-ui-react';

import { sumArray, formatDate } from '../../constants';
import { BRAND } from '../../brand';
import { criterionOutcome } from '../evaluation_sessions/evaluationRules';



const PartnerEvaluationComparison = ({
  partner_evaluation_session,
  eos_evaluation_session,
}) => {
  // Define constructs
  const user = useSelector(state => state.auth.user);
  const max_score = sumArray(
    partner_evaluation_session.partnerevaluatedcriterion_set.map(
      evaluatedcriterion => evaluatedcriterion.criterion.score
    )
  );

  // Calculate similarity based on agreement of criteria
  let agreement_count = 0;
  let total_count = 0;
  const disagreements = [];

  partner_evaluation_session.partnerevaluatedcriterion_set.forEach(
    partner_dataset => {
      const eos_dataset = eos_evaluation_session.evaluatedcriterion_set.find(
        eos_data =>
          eos_data.criterion.int_id === partner_dataset.criterion.int_id
      );

      if (eos_dataset) {
        total_count += 1;
        const partner_met = !!partner_dataset.result.is_criterion_met;
        const eos_met = !!eos_dataset.result.is_criterion_met;

        if (partner_met === eos_met) {
          agreement_count += 1;
        } else {
          disagreements.push({
            int_id: partner_dataset.criterion.int_id,
            text: partner_dataset.criterion.text,
            tags: partner_dataset.criterion.tags,
            partner_result: partner_dataset.result,
            eos_result: eos_dataset.result,
            partner_outcome: criterionOutcome(partner_dataset.criterion.score, partner_met),
            eos_outcome: criterionOutcome(partner_dataset.criterion.score, eos_met),
          });
        }
      }
    }
  );


  const similarity_score =
    total_count === 0 ? 0 : (agreement_count / total_count) * 100;


  // Define States
  const [showInProgressResult, setShowInProgressResult] = useState(false);

  // If the EOS Evaluation is processing, Do not show the comparison result.
  if (eos_evaluation_session.is_postprocessing && !showInProgressResult) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '60px 24px',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            width: '72px',
            height: '72px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, rgba(0,122,255,0.1), rgba(88,86,214,0.1))',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '20px',
          }}
        >
          <Icon name="sync alternate" size="large" style={{ margin: 0, color: '#007AFF' }} />
        </div>
        <h2
          style={{
            fontSize: '20px',
            fontWeight: '600',
            color: '#1d1d1f',
            margin: '0 0 8px 0',
          }}
        >
          비교 결과
        </h2>
        <p style={{ fontSize: '15px', color: '#86868b', margin: '0 0 24px 0' }}>
          {BRAND} 평가가 아직 처리 중입니다.
        </p>

        {user.is_staff && (
          <Button
            onClick={() => setShowInProgressResult(true)}
            style={{
              borderRadius: '25px',
              background: 'linear-gradient(45deg, #007AFF, #0055FF)',
              color: 'white',
              fontWeight: '600',
              padding: '12px 32px',
              boxShadow: '0 6px 16px rgba(0,122,255,0.3)',
              border: 'none',
              transition: 'all 0.3s ease',
            }}
          >
            진행 중인 결과 보기
          </Button>
        )}
      </div>
    );
  }

  const similarityColor =
    similarity_score >= 80 ? '#34C759' : similarity_score >= 50 ? '#FF9500' : '#FF3B30';

  return (
    <div style={{ padding: '0 4px' }}>
      {/* Top Stats */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '24px',
          padding: '16px 20px',
          background: 'white',
          borderRadius: '16px',
          border: '1px solid rgba(0,0,0,0.05)',
          boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div
            style={{
              width: '42px',
              height: '42px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #007AFF, #5856D6)',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '17px',
              fontWeight: '600',
            }}
          >
            {partner_evaluation_session.chat_session.trainee.username
              ? partner_evaluation_session.chat_session.trainee.username[0].toUpperCase()
              : 'U'}
          </div>
          <div>
            <div
              style={{ fontSize: '15px', fontWeight: '600', color: '#1d1d1f' }}
            >
              {partner_evaluation_session.chat_session.trainee.username}
            </div>
            <div style={{ fontSize: '12px', color: '#86868b' }}>
              {formatDate(partner_evaluation_session.created_at)}
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '8px' }}>
          <div
            style={{
              textAlign: 'center',
              padding: '10px 18px',
              borderRadius: '12px',
              backgroundColor: '#F5F5F7',
            }}
          >
            <div
              style={{
                fontSize: '11px',
                color: '#86868b',
                marginBottom: '4px',
                fontWeight: '500',
                textTransform: 'uppercase',
                letterSpacing: '0.3px',
              }}
            >
              Apple
            </div>
            <div
              style={{ fontSize: '18px', fontWeight: '700', color: '#1d1d1f' }}
            >
              {partner_evaluation_session.total_score}
              <span style={{ color: '#aaa', fontSize: '12px', fontWeight: '400' }}>
                /{max_score}
              </span>
            </div>
          </div>
          <div
            style={{
              textAlign: 'center',
              padding: '10px 18px',
              borderRadius: '12px',
              backgroundColor: '#F5F5F7',
            }}
          >
            <div
              style={{
                fontSize: '11px',
                color: '#86868b',
                marginBottom: '4px',
                fontWeight: '500',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '4px',
                textTransform: 'uppercase',
                letterSpacing: '0.3px',
              }}
            >
              {BRAND}
              <Icon
                name="external"
                size="small"
                style={{ cursor: 'pointer', color: '#007AFF' }}
                onClick={() =>
                  window.open(
                    `/chatsessions/${eos_evaluation_session.chat_session.id}`,
                    '_blank'
                  )
                }
              />
            </div>
            <div
              style={{ fontSize: '18px', fontWeight: '700', color: '#1d1d1f' }}
            >
              {eos_evaluation_session.total_score}
              <span style={{ color: '#aaa', fontSize: '12px', fontWeight: '400' }}>
                /{max_score}
              </span>
            </div>
          </div>
          <div
            style={{
              textAlign: 'center',
              padding: '10px 18px',
              borderRadius: '12px',
              backgroundColor: `${similarityColor}10`,
              border: `1px solid ${similarityColor}30`,
            }}
          >
            <div
              style={{
                fontSize: '11px',
                color: '#86868b',
                marginBottom: '4px',
                fontWeight: '500',
                textTransform: 'uppercase',
                letterSpacing: '0.3px',
              }}
            >
              유사도
            </div>
            <div
              style={{ fontSize: '18px', fontWeight: '700', color: similarityColor }}
            >
              {similarity_score.toFixed(0)}%
            </div>
          </div>
        </div>
      </div>

      {/* Disagreement List */}
      <div
        style={{
          background: 'white',
          borderRadius: '16px',
          border: '1px solid rgba(0,0,0,0.05)',
          boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '16px 20px',
            borderBottom: '1px solid rgba(0,0,0,0.05)',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '10px',
                background: disagreements.length > 0
                  ? 'rgba(255, 149, 0, 0.1)'
                  : 'rgba(52, 199, 89, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Icon
                name={disagreements.length > 0 ? 'exchange' : 'check circle'}
                style={{
                  margin: 0,
                  color: disagreements.length > 0 ? '#FF9500' : '#34C759',
                  fontSize: '14px',
                }}
              />
            </div>
            <h3
              style={{
                fontSize: '15px',
                fontWeight: '600',
                color: '#1d1d1f',
                margin: 0,
              }}
            >
              불일치 항목 분석
            </h3>
          </div>
          <Label
            circular
            size="small"
            style={{
              background: disagreements.length > 0 ? '#FF9500' : '#34C759',
              color: 'white',
              fontWeight: '600',
            }}
          >
            {disagreements.length}
          </Label>
        </div>

        {disagreements.length > 0 ? (
          <Table basic="very" style={{ margin: 0, border: 'none' }}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell
                  width={6}
                  style={{
                    color: '#86868b',
                    fontSize: '11px',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    borderBottom: '1px solid rgba(0,0,0,0.06)',
                    padding: '10px 16px',
                  }}
                >
                  평가 항목
                </Table.HeaderCell>
                <Table.HeaderCell
                  width={2}
                  style={{
                    color: '#86868b',
                    fontSize: '11px',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    borderBottom: '1px solid rgba(0,0,0,0.06)',
                    padding: '10px 16px',
                  }}
                >
                  카테고리
                </Table.HeaderCell>
                <Table.HeaderCell
                  width={2}
                  textAlign="center"
                  style={{
                    color: '#86868b',
                    fontSize: '11px',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    borderBottom: '1px solid rgba(0,0,0,0.06)',
                    padding: '10px 16px',
                  }}
                >
                  Apple
                </Table.HeaderCell>
                <Table.HeaderCell
                  width={2}
                  textAlign="center"
                  style={{
                    color: '#86868b',
                    fontSize: '11px',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    borderBottom: '1px solid rgba(0,0,0,0.06)',
                    padding: '10px 16px',
                  }}
                >
                  {BRAND}
                </Table.HeaderCell>
                <Table.HeaderCell
                  width={2}
                  textAlign="center"
                  style={{
                    color: '#86868b',
                    fontSize: '11px',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    borderBottom: '1px solid rgba(0,0,0,0.06)',
                    padding: '10px 16px',
                  }}
                >
                  AI 확신도
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {disagreements.map((item, index) => (
                <Table.Row
                  key={index}
                  style={{
                    transition: 'background-color 0.15s ease',
                  }}
                >
                  <Table.Cell style={{ padding: '12px 16px' }}>
                    <div
                      style={{
                        fontSize: '13px',
                        fontWeight: '500',
                        color: '#1d1d1f',
                        lineHeight: '1.5',
                      }}
                    >
                      {item.text}
                    </div>
                    <div style={{ fontSize: '11px', color: '#86868b', marginTop: '4px' }}>
                      ID: {item.int_id + 1}
                    </div>
                  </Table.Cell>
                  <Table.Cell style={{ padding: '12px 16px' }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                      {item.tags &&
                        item.tags.split(',').map((tag, idx) => (
                          <span
                            key={idx}
                            style={{
                              fontSize: '11px',
                              padding: '2px 8px',
                              borderRadius: '10px',
                              backgroundColor: '#F5F5F7',
                              color: '#6e6e73',
                              fontWeight: '500',
                            }}
                          >
                            {tag.trim()}
                          </span>
                        ))}
                    </div>
                  </Table.Cell>
                  <Table.Cell textAlign="center" style={{ padding: '12px 16px', verticalAlign: 'middle' }}>
                    <span
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '5px',
                        padding: '4px 10px',
                        borderRadius: '10px',
                        fontSize: '12px',
                        fontWeight: '600',
                        backgroundColor: item.partner_outcome.favorable ? 'rgba(52,199,89,0.1)' : 'rgba(255,59,48,0.1)',
                        color: item.partner_outcome.favorable ? '#34C759' : '#FF3B30',
                        lineHeight: '18px',
                      }}
                    >
                      <Icon name={item.partner_outcome.favorable ? 'check' : 'times'} style={{ margin: 0, fontSize: '11px', lineHeight: '18px', display: 'flex', alignItems: 'center' }} />
                      {item.partner_outcome.label}
                    </span>
                  </Table.Cell>
                  <Table.Cell textAlign="center" style={{ padding: '12px 16px', verticalAlign: 'middle' }}>
                    <span
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '5px',
                        padding: '4px 10px',
                        borderRadius: '10px',
                        fontSize: '12px',
                        fontWeight: '600',
                        backgroundColor: item.eos_outcome.favorable ? 'rgba(52,199,89,0.1)' : 'rgba(255,59,48,0.1)',
                        color: item.eos_outcome.favorable ? '#34C759' : '#FF3B30',
                        lineHeight: '18px',
                      }}
                    >
                      <Icon name={item.eos_outcome.favorable ? 'check' : 'times'} style={{ margin: 0, fontSize: '11px', lineHeight: '18px', display: 'flex', alignItems: 'center' }} />
                      {item.eos_outcome.label}
                    </span>
                  </Table.Cell>
                  <Table.Cell textAlign="center" style={{ padding: '12px 16px', verticalAlign: 'middle' }}>
                    {item.eos_result.confidence ? (
                      <div
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '5px',
                          padding: '5px 12px',
                          borderRadius: '10px',
                          background: 'linear-gradient(135deg, rgba(0,122,255,0.08), rgba(88,86,214,0.08))',
                          border: '1px solid rgba(0,122,255,0.12)',
                        }}
                      >
                        {/* <Icon name="brain" style={{ margin: 0, fontSize: '12px', color: '#5856D6', display: 'flex', alignItems: 'center' }} /> */}
                        <span
                          style={{
                            fontSize: '14px',
                            fontWeight: '700',
                            color: '#007AFF',
                          }}
                        >
                          {(item.eos_result.confidence * 100).toFixed(0)}%
                        </span>
                      </div>
                    ) : (
                      <span style={{ fontSize: '12px', color: '#c7c7cc' }}>—</span>
                    )}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        ) : (
          <div
            style={{
              textAlign: 'center',
              padding: '48px 24px',
              color: '#86868b',
            }}
          >
            <div
              style={{
                width: '56px',
                height: '56px',
                borderRadius: '50%',
                background: 'rgba(52, 199, 89, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px',
              }}
            >
              <Icon name="check" style={{ margin: 0, color: '#34C759', fontSize: '22px' }} />
            </div>
            <p style={{ fontSize: '15px', fontWeight: '500', margin: 0 }}>
              모든 평가 항목이 일치합니다.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PartnerEvaluationComparison;
